// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-no-translate]{translate:none;-webkit-user-select:none;-moz-user-select:none;user-select:none}.vfMVP{margin:24px auto;max-width:1120px;padding:0 24px}.wNAzS{margin-bottom:24px;padding:24px;width:100%}.EQGci{margin-right:8px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "vfMVP",
	"section": "wNAzS",
	"buttonProgress": "EQGci"
};
module.exports = ___CSS_LOADER_EXPORT___;
